import React, { useRef, useState, useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption, IYhFormRef } from "@/components/YhFormBoxVertical/Types";
import { useVehicleModel } from "../vehicleModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IVehicleDetail } from "../vehicleType";
import { getFormValidatorErrText } from "@/utils/utils"
import { DetailType } from "@/types/ScmEnums";
import useGlobalModel, { getFindItem, transOptions } from "@/model/globalModel";
import { ITreeSelectData, useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { debounce } from "lodash";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YHDetailNav } from "@/components/YHDetailNav";
import { useOrgModel } from "@/views/organization/org/orgModel";
import moment, { Moment } from "moment"

export const BaseVehicleDetails = () => {
    const { CustomerData } = useGlobalModel()
    const { getSelectedDictOne } = useDictModel();

    const { treeSource, getOrgTreeSelect } = useOrgModel();
    const {
        addFormVal,
        editFormVal,
        lookFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertDetail,
        editDetail,
        getDetailOne,
        setAddFormVal,
        setSelectedRowKeys,
        saveLoading, setSaveLoading
    } = useVehicleModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode, parentInfo } = detailsInfo
    const typeForm = {
        add: addFormVal,
        edit: editFormVal,
        look: lookFormVal
    }
    const [orgList, setOrgList] = useState<any>([]);
    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && mode === "edit") {
            getDetailOne(id, mode)
        }
        mode === "look" && getDetailOne(id, mode)

    }, [detailsInfo]);
    useEffect(() => {
        if (parentInfo) {
            let { customerCode } = parentInfo
            updateAddFormVal({ customerCode })
        }

    }, [parentInfo])
    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-5-2-1");
            let editNavExist = findNav("13-5-2-2");
            !addNavExist && updateAddFormVal(null);
            !editNavExist && updateEditFormVal(null);
        }
    }, [])
    useEffect(() => {
        let name = getFindItem(typeForm[mode].customerCode as string, CustomerData)?.name;
        let newOrgList: any = getOrgTreeSelect(DictCodeEnmu.ORG)[0].children.find((item) => item.title === name)
        setOrgList(newOrgList?.children ? newOrgList?.children : [])
    }, [typeForm[mode].customerCode])
    //关闭当前页
    const onClose = () => {
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "13-5-2");
            detailsInfo.mode === "edit" ? updateEditFormVal(null) : updateAddFormVal(null);
        }
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            res.nextMaintenanceTime = res.nextMaintenanceTime ? moment(res.endTime).format("YYYY-MM-DD HH:mm:ss") : ''
            res.registerDate = res.endTime ? moment(res.registerDate).format("YYYY-MM-DD HH:mm:ss") : ''
            if (detailsInfo.mode === "edit") {
                editDetail({
                    ...res,
                    id: detailsInfo.id, code: editFormVal.code, enable: editFormVal.enable
                } as IVehicleDetail).then(res => {
                    res && onClose()
                })
            } else {
                insertDetail({
                    ...res as IVehicleDetail,
                    enable: 1
                }).then(res => {
                    setSelectedRowKeys([res as string])
                    res && onClose()
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }
    //机构选中
    const onTreeSelectChange = (value: string, node: ITreeSelectData) => {
        detailsInfo.mode === "edit" ? updateEditFormVal({ depName: node.title, depCode: value }) : updateAddFormVal({ depName: node.title, depCode: value });
    }
    const baseFormItem: IYhFormItemsBox = {
        title: "基本信息",
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "客户名称",
                fieldName: "customerCode",
                allowClear: true,
                showSearch: true,
                onSelectChange: (value, option) => {
                    detailsInfo.mode === "edit" ? updateEditFormVal({ customerCode: value, customerName: '', depCode: '', depName: '' }) : updateAddFormVal({ customerCode: value, customerName: '', depCode: '', depName: '' });
                },
                options: transOptions(CustomerData),
                rules: [{ required: true, message: "请输入客户名称" }]
            }, {
                type: FormItemTypeEnum.TreeSelect,
                fieldLabel: "部门",
                fieldName: "depCode",
                onTreeSelectChange,
                treeData: orgList,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆牌照",
                fieldName: "licensePlate",
                rules: [{ required: true, message: "请输入车辆牌照" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发动机号",
                fieldName: "engineCode"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆型号",
                fieldName: "model"
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "车辆类型",
                fieldName: "categoryCode",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                rules: [{ required: true, message: "请选择车辆类型" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "变速箱号",
                fieldName: "gearboxCode"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "使用性质",
                fieldName: "natureCode"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车桥",
                fieldName: "axle"
            }, {
                type: FormItemTypeEnum.Select,//VEHICLE_BRAND
                fieldLabel: "车辆品牌",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_BRAND),
                fieldName: "brandCode",
                rules: [{ required: true, message: "请输入车辆品牌" }]
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "注册日期",
                fieldName: "registerDate",
                format: "YYYY-MM-DD HH:mm:ss",
                showTime: { defaultValue: moment("00:00:00", "HH:mm:ss") },
            }, {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: "下次保养时间",
                fieldName: "nextMaintenanceTime",
                format: "YYYY-MM-DD HH:mm:ss",
                showTime: { defaultValue: moment("00:00:00", "HH:mm:ss") },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车系",
                fieldName: "series"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "Vin码",
                fieldName: "vin",
                rules: [{ required: true, message: "请选择vin码" }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "吨位",
                fieldName: "tonnage",
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆编号",
                fieldName: "vehicleNumber",
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "机构名称",
                fieldName: "depName",
                hidden: true
            },
        ]
    };

    const otherFormItem: IYhFormItemsBox = {
        title: "其它信息",
        // disabled: true,
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建人",
                fieldName: "createUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "创建时间",
                fieldName: "createTime",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改人",
                fieldName: "updateUser",
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "修改时间",
                fieldName: "updateTime",
                disable: true,
            }
        ]
    }

    const priceFormItem: IYhFormItemsBox = {
        title: "保养信息（字段暂无）",
        style: { marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "上次保养日期",
                fieldName: "createTime"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "上次保养里程",
                fieldName: "createTime"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "下次保养日期",
                fieldName: "createTime"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "下次保养里程",
                fieldName: "createTime"
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "最新里程",
                fieldName: "createTime"
            }
        ]
    }


    const typeTitle = {
        add: "新增",
        edit: "编辑",
        look: "查看",
    }
    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        disabled: mode == DetailType.look,
        labelAlign: "right",
        // formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        formValues: { ...typeForm[mode] },
        onChange,
        // boxs: [baseFormItem, priceFormItem,otherFormItem]
        boxs: [baseFormItem, otherFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({})
        } else if (detailsInfo.mode === "edit") {
            getDetailOne(detailsInfo.id, mode)
        }
        message.success("重置成功")
    }
    const action = <>
        {mode != "look" &&
            <YhAuth resCode={ResourceAuthEnum.DATA_C_V_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { onSubmit() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>}
        {mode != "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={() => reset()}
        >重置</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onClose}
        >取消</Button>
    </>;

    return (
        <>
            {/* <YhPageHeader title="车辆详情" /> */}
            {/* <YhBox title={`车辆${typeTitle[mode]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox> */}
            <YHDetailNav
                title={`车辆${typeTitle[mode]}`}
                btns={action}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}